// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__dzZsW","flag":"style_flag__TIgXs","abbr":"style_abbr__P_5xf","date":"style_date__q87a4","fullLink":"style_fullLink__2kmOo"};